import React from 'react';
import { Route, Routes } from 'react-router'
import { MailIcon, MarkGithubIcon } from '@primer/octicons-react'
import { LinkButton } from '@primer/react'
import './App.css'
import './site.scss';
import linkedinlogo from './assets/InBug-Black.png';
import About from './pages/About'
import Nav from './pages/Nav'
import Projects from './pages/Projects'
import Resume from './pages/Resume'

export default function App() {
  return (
    <>
      <Header />
      <Nav />

      <main className="d-flex flex-1 flex-justify-center">
        <Routes>
          <Route path="/" element={<About />} />
          <Route path='/resume' element={<Resume />} />
          <Route path="/projects" element={<Projects />} />
        </Routes>
      </main>

      <Footer />
    </>
  )

  function Header(): React.ReactElement {
    return (
      <header className="d-flex flex-column text-center flex-items-center mb-5">
        <h1 className="mb-0">Maya Lopez</h1>
        <h2 className="nee-names">(Messinger Rumple)</h2>
        <h2 className="m-0">Senior Software Engineer</h2>
      </header>
    );
  }

  function Footer(): React.ReactElement {
    return (
      <footer>
        <LinkButton icon={LinkedInIcon} as="a" href="https://www.linkedin.com/in/mayalopezmr/" aria-label="LinkedIn profile" variant="invisible" />
        <LinkButton icon={MarkGithubIcon} as="a" href="https://github.com/mayamessinger" aria-label="GitHub profile" variant="invisible" />
        <LinkButton icon={MailIcon} as="a" href="mailto:mayalopezmr@gmail.com" aria-label="email address" variant="invisible" />
      </footer>
    );
  }

  function LinkedInIcon() {
    return <img src={linkedinlogo} className="linkedin-icon" alt="LinkedIn"/>;
  }
}